import axios from "../../utils/axios";

// 服务管理
export function listService(query) {
    return axios({
        url: "serviceManage/getList",
        method: "get",
        params: query
    });
}

//服务上下架
export function upDownService(data) {
    return axios({
        url: "serviceManage/updown",
        method: "post",
        data: data
    });
}
//服务删除
export function deleteService(data) {
    return axios({
        url: "serviceManage/delete",
        method: "post",
        data: data
    });
}
// 服务增加
export function addSysMsg(data) {
    return axios({
        url: "serviceManage/update",
        method: "post",
        data: data
    });
}

// 服务修改
export function updateSysMsg(data) {
    return axios({
        url: "serviceManage/update",
        method: "post",
        data: data
    });
}

